export const firebaseConfig = {
    apiKey: "AIzaSyCoXDPqGSNsXonGUo341mp1sZujDBFyrK0",
    authDomain: "playground-chatbot-529d4.firebaseapp.com",
    databaseURL: "https://playground-chatbot-529d4.firebaseio.com",
    projectId: "playground-chatbot-529d4",
    storageBucket: "playground-chatbot-529d4.appspot.com",
    messagingSenderId: "611123901181",
    appId: "1:611123901181:web:1c673c76676eb86f0b4494",
    measurementId: "G-NNWSXQ7C6M"
};